// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'

// types
interface ListStudiesProps {
    className?: string
    isAnimated?: boolean
    title?: string
    intro?: string
    cards?: {
        image?: {
            src?: string
            alt?: string
        }
        tag?: string
        title?: string
        description?: string
        href?: {
            href?: string
            external?: boolean
        }
    }[]
}

// css
import './index.scss'

export default function ListStudies({
    className,
    isAnimated,
    title,
    intro,
    cards
}: ListStudiesProps) {
    return (
        <Section className={clsx(
            'list-studies-component',
            className
        )}>
            <div className='container'>

                {title && (
                    <h2 className='h2'>
                        {title}
                    </h2>
                )}

                {intro && (
                    <div
                        className='lead-paragraph list-studies-component__intro'
                        dangerouslySetInnerHTML={{
                            __html: intro
                        }}
                    />
                )}

                {cards && (
                    <div
                        className='list-studies-component__cards'
                        data-stagger-up={isAnimated ? 'true' : 'false'}
                    >
                        {cards?.map((item, i) => (
                            <a
                                className='list-studies-component__card'
                                href={item.href?.href}
                                target={item.href?.external ? '_blank' : undefined}
                                rel={item.href?.external ? 'noopener noreferrer' : undefined}
                                key={i}
                            >

                                <div className='list-studies-component__card__media'>
                                    {item.image?.src && (
                                        <Image
                                            src={{ src: item.image.src, width: 720, height: 480 }}
                                            alt={item.image.alt || ''}
                                            className='cover'
                                            sizes='(max-width: 575px) 100vw, 25vw'
                                        />
                                    )}
                                </div>

                                <div className='list-studies-component__card__content'>

                                    {item.tag && (
                                        <span className='body-x-small list-studies-component__card__tag'>
                                            {item.tag}
                                        </span>
                                    )}

                                    {item.title && (
                                        <h3 className='h4 list-studies-component__card__title'>
                                            {item.title}
                                        </h3>
                                    )}

                                    {item.description && (
                                        <div
                                            className='body list-studies-component__card__description'
                                            dangerouslySetInnerHTML={{
                                                __html: item.description
                                            }}
                                        />
                                    )}

                                </div>

                            </a>
                        ))}
                    </div>
                )}

            </div>
        </Section>
    )
}
